export class TokenInfo {
  registrationToken: string;
  userId: string;
  partnerId: string;
  deviceId: string;

  constructor(registrationToken: string, userId: string, partnerId: string, deviceId: string) {
    this.registrationToken = registrationToken;
    this.userId = userId;
    this.partnerId = partnerId;
    this.deviceId = deviceId;
  }

  equals(other: TokenInfo): boolean {
    return (
      this.registrationToken === other.registrationToken &&
      this.userId === other.userId &&
      this.partnerId === other.partnerId &&
      this.deviceId === other.deviceId
    );
  }
}

// Determines if the screen is a mobile phone sized screen
export function isMobile(): boolean {
  return window.matchMedia('(max-width: 767px)').matches;
}
